var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkiGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7796 29.0657L31.5932 29.7626C31.303 30.847 30.3213 31.601 29.1997 31.601H10.7478C9.85843 31.601 9.13745 32.3227 9.13745 33.2129C9.13745 34.102 9.85737 34.8247 10.7478 34.8247H30.4872C32.4098 34.8247 34.0425 33.4153 34.3249 31.5118L34.7301 28.7816C34.8233 28.1533 34.3369 27.5889 33.7023 27.5889C32.8042 27.5889 32.0135 28.1918 31.7796 29.0657V29.0657Z",
    fill: "#CAD1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7214 26.1427V22.3562C18.7214 21.937 18.3819 21.5973 17.9632 21.5973H15.3102C14.8915 21.5973 14.552 21.937 14.552 22.3562V31.601H23.535V29.7195C23.535 28.315 22.3975 27.1764 20.9942 27.1764H19.7541C19.1838 27.1764 18.7214 26.7136 18.7214 26.1427V26.1427Z",
    fill: "#80E5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7214 24.8327V22.3562C18.7214 21.937 18.3819 21.5973 17.9632 21.5973H15.3102C14.8915 21.5973 14.552 21.937 14.552 22.3562V24.8327H18.7214Z",
    fill: "#FFC764"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5521 13.953H11.279C10.5122 13.953 9.89062 13.3314 9.89062 12.5646C9.89062 11.6959 10.5546 11.1316 11.279 11.1316H14.5521V13.953Z",
    fill: "#FF637D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8726 11.6517H14.552V13.4329H32.8726C33.3644 13.4329 33.7632 13.0341 33.7632 12.5423C33.7632 12.0505 33.3644 11.6517 32.8726 11.6517Z",
    fill: "#A27B7C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2112 17.1216H31.4842C32.251 17.1216 32.8726 17.7432 32.8726 18.51C32.8726 19.3786 32.2086 19.943 31.4842 19.943H28.2112V17.1216Z",
    fill: "#FF637D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2112 17.6418C25.4954 17.6418 12.6359 17.6418 9.89058 17.6418C9.39876 17.6418 9 18.0406 9 18.5324C9 19.0242 9.39876 19.423 9.89058 19.423H28.2112V17.6418Z",
    fill: "#A27B7C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7238 21.0747C11.232 21.0747 10.8333 20.676 10.8333 20.1842V16.8806C10.8333 16.3887 11.232 15.99 11.7238 15.99C12.2156 15.99 12.6144 16.3887 12.6144 16.8806V20.1842C12.6144 20.676 12.2156 21.0747 11.7238 21.0747V21.0747Z",
    fill: "#545178"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0393 15.0847C30.5474 15.0847 30.1487 14.686 30.1487 14.1942V10.8906C30.1487 10.3988 30.5474 10 31.0393 10C31.5311 10 31.9298 10.3988 31.9298 10.8906V14.1942C31.9298 14.686 31.5311 15.0847 31.0393 15.0847Z",
    fill: "#545178"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkiGear);
export default __webpack_public_path__ + "static/media/ski_gear.b1dce284276c86f0aad88243d5eeac91.svg";
export { ForwardRef as ReactComponent };